import LoadingComponent, {
  EmptyLoading
} from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'
export default [
  {
    path: '/courierView/serviceScore/home',
    component: Loadable({
      loader: () => import('@/pages/serviceScore/home'),
      loading: EmptyLoading
    })
  },
  {
    path: '/courierView/serviceScore/detail/:statDate',
    component: Loadable({
      loader: () => import('@/pages/serviceScore/detail'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/serviceScore/scoreRecord',
    component: Loadable({
      loader: () => import('@/pages/serviceScore/scoreRecord'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/serviceScore/changeRecord',
    component: Loadable({
      loader: () => import('@/pages/serviceScore/changeRecord'),
      loading: LoadingComponent
    })
  },
  {
    path: '/courierView/serviceScore/rules',
    component: Loadable({
      loader: () => import('@/pages/serviceScore/rules'),
      loading: LoadingComponent
    })
  },
  // 服务分v2版
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/ruleInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/ruleInfo',
    meta: {
      title: '服务分说明'
    }
  },
  // 服务分v2版
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/violationBill/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/violationBill',
    meta: {
      title: '违规账单'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/violateInfo/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/violateInfo',
    meta: {
      title: '违规行为说明'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/main/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/main',
    meta: {
      title: '服务分'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/detail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/detail',
    meta: {
      title: '服务星明细'
    }
  },
  // 服务星明细新版（服务星总览四宫格入口）
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/starDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/starDetail',
    meta: {
      title: '服务星明细'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/commitment/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/commitment',
    meta: {
      title: '服务承诺书'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/serviceScore/v2/siteSelection/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/serviceScore/v2/siteSelection',
    meta: {
      title: '站点选择'
    }
  }
]
